// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badges[data-v-70e937d4] {\n  height: 62px;\n  text-align: left;\n}\n.badges img[data-v-70e937d4] {\n  display: inline-block;\n  width: auto;\n  height: 62px;\n}\n.compact span[data-v-70e937d4] {\n  white-space: nowrap;\n  display: inline-block;\n  margin-right: 3px;\n}\n.myLegend span[data-v-70e937d4] {\n  white-space: nowrap;\n  display: block;\n}", ""]);
// Exports
module.exports = exports;
